const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3010';

class BillingService {
  async getBillingData() {
    const res = await fetch(`${BACKEND_URL}/api/billing`);
    if (!res.ok) throw new Error(`Error obteniendo datos de billing: ${res.status}`);
    return res.json();
  }

  async getSupabaseHealth() {
    const res = await fetch(`${BACKEND_URL}/api/health/supabase`);
    if (!res.ok) throw new Error(`Error obteniendo health de Supabase: ${res.status}`);
    return res.json();
  }
}

export default new BillingService();
